import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GridColumn, MxCustomizableCustomizer, MxGridCustomizerEvent, MxGridHandleOrder, ProductTypeObj} from 'mx-core';

@Component({
    selector: 'prl-product-type',
    standalone: false,
    template: `
        <mx-grid class="prl-grid-screen" (customize)="onCustomize($event)">
        </mx-grid>`
})
export class PrlProductTypesComponent implements OnInit,
    MxGridHandleOrder<ProductTypeObj>, MxCustomizableCustomizer<MxGridCustomizerEvent> {


    private gridColumns: Array<GridColumn> = [];

    @Output()
    customize: EventEmitter<MxGridCustomizerEvent> = new EventEmitter<MxGridCustomizerEvent>();

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({field: 'id', sortable: true, label: 'ID', hidden: true}),
            new GridColumn({field: 'name', sortable: true, label: 'Name', columnWidth: 200, idProp: 'id'}),
            new GridColumn({field: 'description', sortable: true, label: 'Description', columnWidth: 200}),
            new GridColumn({field: 'order', label: 'Order', sortable: true, columnWidth: 200})
        ];

    }

    onCustomize(event: MxGridCustomizerEvent): void {
        event.customizeLoadRowsOnStart(true)
            .customizeRestUrl('/product-types/with-products')
            .customizeColumns(this.gridColumns)
            .customizeProps({
                noPagination: true,
                sortActive: 'name',
                sortDirection: 'asc',
                selectionMode: 'multi'
            })
            .customizeOrder(this);

        this.customize.emit(event);
    }


    getOrder(record: ProductTypeObj): number {
        return record.order;
    }

    setOrder(order: number, record: ProductTypeObj) {
        record.order = order;
        return record;
    }
}
